export default __webpack_public_path__ + "static/media/mati_logo.abb890ba.png";